<template lang="pug">
    section#transferencia
        div.wrapper
            h2 Em Breve Transferência
            //- ul
                li
                    p
                        |Transfira
                        br
                        |seu curso
                        br
                        |para UniFAEL
                li._02
                    div
                        span
                            |E ganhe até
                        strong
                            |60
                            sup %
                    p
                        |de desconto nas mensalidades,
                li
                    p
                        |até o fim
                        br
                        |do curso.
            p.rapido
                |É rápido, fácil e garantimos a conclusão
                sup 1
                |do curso no mesmo prazo da sua faculdade de origem.
</template>

<script>
export default {
    name: "section-transferencia"
}
</script>

<style lang="stylus" scoped src="./Transferencia.styl"></style>
